import {useEffect} from 'react';

import {generateCallback} from '/util/component.util';
import {useStateWithPrevious} from '/util/hooks/useStateWithPrevious.hook';

import {
  generatePerformanceOnMount,
  generateUpdatePerformanceMetrics,
  generateUpdateProgressionData,
} from './Performance.util';

interface UsePerformanceParams {
  getPerformanceMetrics: () => void;
  getRankProgression: () => void;
  hasPerformanceMetrics: boolean;
  hasProgressionData: boolean;
}

export function usePerformance({
  getPerformanceMetrics,
  getRankProgression,
  hasPerformanceMetrics,
  hasProgressionData,
}: UsePerformanceParams) {
  const [
    {
      // @ts-expect-error TS(2339): Property 'previous' does not exist on type '((newV... Remove this comment to see the full error message
      previous: previousHasPerformanceMetrics,
      // @ts-expect-error TS(2339): Property 'value' does not exist on type '((newValu... Remove this comment to see the full error message
      value: currentHasPerformanceMetrics,
    },
    setHasPerformanceMetrics,
  ] = useStateWithPrevious(hasPerformanceMetrics);

  const [
    // @ts-expect-error TS(2339): Property 'previous' does not exist on type '((newV... Remove this comment to see the full error message
    {previous: previousHasProgressionData, value: currentHasProgressionData},
    setHasProgressionData,
  ] = useStateWithPrevious(hasProgressionData);

  // Used to update previousHasPerformanceMetrics value
  useEffect(
    generateCallback({
      func: setHasPerformanceMetrics,
      params: hasPerformanceMetrics,
    }),
    [hasPerformanceMetrics],
  );

  // Used to update previousHasProgressionData value
  useEffect(
    generateCallback({
      func: setHasProgressionData,
      params: hasProgressionData,
    }),
    [hasProgressionData],
  );

  useEffect(() => {
    generatePerformanceOnMount({
      getPerformanceMetrics,
      getRankProgression,
      hasPerformanceMetrics,
      hasProgressionData,
    })();
  }, []);

  useEffect(() => {
    generateUpdatePerformanceMetrics({
      currentHasPerformanceMetrics,
      getPerformanceMetrics,
      previousHasPerformanceMetrics,
    })();
  }, [previousHasPerformanceMetrics, currentHasPerformanceMetrics]);

  useEffect(() => {
    generateUpdateProgressionData({
      currentHasProgressionData,
      getRankProgression,
      previousHasProgressionData,
    })();
  }, [previousHasProgressionData, currentHasProgressionData]);
}
